import { OFFLINE_STEPS_DATABASE_NAME_PREFIX } from '../database-schema.ts';
import {
	getIndexedDbDatabases,
	UNSAFE_openStrictlyNecessaryIndexedDbRequest,
} from '../indexed-db.ts';

export function clearOfflineStepsDatabases(): void {
	if ('indexedDB' in window) {
		void getIndexedDbDatabases().then((databases) => {
			const offlineStepsDatabases = databases.filter(
				(db) => db.name && db.name.startsWith(OFFLINE_STEPS_DATABASE_NAME_PREFIX),
			);

			offlineStepsDatabases.forEach((db) => {
				if (!db.name) {
					return;
				}

				const openRequest = UNSAFE_openStrictlyNecessaryIndexedDbRequest(db.name);
				openRequest.onsuccess = () => {
					const idb = openRequest.result;
					try {
						const tx = idb.transaction(['steps', 'meta'], 'readwrite');
						tx.objectStore('steps').clear();
						tx.objectStore('meta').clear();
						tx.oncomplete = () => {
							idb.close();
						};
						tx.onerror = () => {
							idb.close();
						};
					} catch {
						idb.close();
					}
				};
			});
		});
	}
}
